import CartIcon from "~/assets/icons/CartIcon"
import FacebookIcon from "~/assets/icons/FacebookIcon"
import InstagramIcon from "~/assets/icons/InstagramIcon"
import LinkedinIcon from "~/assets/icons/LinkedinIcon"
import Logo from "~/assets/icons/Logo"
import MailHeader from "~/assets/icons/MailHeader"
import PhoneHeader from "~/assets/icons/PhoneHeader"
import PinterestIcon from "~/assets/icons/PinterestIcon"
import SearchIcon from "~/assets/icons/SearchIcon"
import TwitterIcon from "~/assets/icons/TwitterIcon"
import UserIcon from "~/assets/icons/UserIcon"
import VisitHeader from "~/assets/icons/VisitHeader"
import YoutubeIcon from "~/assets/icons/YoutubeIcon"
import { CartDrawer } from "~/rs-components/global/CartDrawer.client"
import CartBadge from "~/rs-components/global/header/CartBadge.client"
import Navigation from "~/rs-components/global/navigation/Navigation.client"
import TrustPilotManagement from "~/rs-components/home/TrustPilotManagement.client"
import { CustomerMetafields } from "~/types"
import { header, contactInfo, trustPilotTop, trustPilotCustomSetting } from "../settings"
import { isNonTransactional } from "../settings/__nonTransactional"
import TrustPilotCustom from "./TrustPilotCustom.client"

type SetupDesktopHeaderProps = {
    setShowCategory: React.Dispatch<React.SetStateAction<string | boolean>>,
    openCart: () => void,
    menuItems: any[]
    showCategory: string | boolean,
    shopSettings: string,
    customer?: CustomerMetafields,
}

export default function SetupDesktopHeader({ setShowCategory, openCart, showCategory, menuItems, shopSettings, customer }: SetupDesktopHeaderProps) {

    return (
        <>
                        
            <div onMouseLeave={() => setShowCategory(false)} className="hidden lg:block top-0 z-50">
                <div className="header flex flex-row items-center px-8" onMouseEnter={() => setShowCategory(false)}>
                    {/* TODO: move image in assets image */}
                    <div className="basis-4/12">
                        <div className="iconsInformation">
                            <a className="iconsInformation__call" href={`tel:${contactInfo?.phone}`}>
                                <i><PhoneHeader /></i>Call {contactInfo?.phone}
                            </a>
                            <a className="iconsInformation__email" href={`mailto:${contactInfo?.mailTo}`}>
                                <i><MailHeader /></i>Email us
                            </a>
                            <a className="iconsInformation__visit" href={contactInfo?.page}>
                                <i><VisitHeader /></i>Visit us
                            </a>
                        </div>
                    </div>
                    <div className="logo basis-4/12">
                        <a className="aLogo" href="https://www.rosevears.co.uk/">
                            <Logo />
                        </a>
                    </div>
                    <div className="topUserArea loginCart basis-4/12 text-right">
                        <div className="topUserArea__search-container">
                            <div className="topUserArea__search">
                                <form action={`/products`} method="GET">
                                    <input name="search" type="search" placeholder="Search..." />
                                    <i className="fa">
                                        <button type='submit' className='buttonSearch'><SearchIcon /></button>
                                    </i>
                                </form>
                            </div>
                        </div>
                        <div className="topUserArea__login">
                            <a href='/account'><UserIcon /></a>
                        </div>
                        <div className="topUserArea__cart">
                            {!isNonTransactional &&
                                <button onClick={openCart} className='relative flex items-center justify-center w-8 h-8'>
                                    <CartIcon />
                                    <CartBadge />
                                </button>
                            }
                        </div>
                    </div>
                </div>
                {trustPilotTop.visibility && trustPilotTop.position == 1 &&
                    <div className="trustPilotMenu">
                        <TrustPilotManagement type={0}></TrustPilotManagement>
                    </div>
                }
                <Navigation css={""} menuItems={menuItems} showCategory={showCategory} setShowCategory={setShowCategory} shopSettings={shopSettings} />
                {trustPilotCustomSetting.header.desktop ? <TrustPilotCustom testimonials={true} ></TrustPilotCustom> : <></>}
            </div>
        </>
    )
}